import AddPhotoAlternateOutlinedIcon from "@mui/icons-material/AddPhotoAlternateOutlined";
import { Box, Button } from "@mui/material";
import { useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import Compressor from "compressorjs";

export default function FileUploader({
  onFileSelect,
  acceptedFileTypes,
  instructionText,
}) {
  const { t } = useTranslation();
  const instruction = instructionText || t("dragAndDropFilesHere");
  const compressImage = async (file) => {
    return new Promise((resolve, reject) => {
      console.log("Compressing image:", file.name);
      new Compressor(file, {
        maxWidth: 1080,
        success(result) {
          console.log("Image compressed successfully:", result.name);
          resolve(result);
        },
        error(err) {
          console.error("Image compression failed:", err);
          reject(err);
        },
      });
    });
  };

  const compressImagesWithSW = async (files) => {
    if ("serviceWorker" in navigator && navigator.serviceWorker.controller) {
      // Service worker communication for compression (not supported for File objects)
      // Fallback to main thread
      return null;
    }
    return null;
  };

  const onDrop = useCallback(
    async (acceptedFiles) => {
      let processedFiles = acceptedFiles;
      let swResult = await compressImagesWithSW(acceptedFiles);
      if (!swResult) {
        processedFiles = await Promise.all(
          acceptedFiles.map(async (file) => {
            if (file.type.startsWith("image/")) {
              try {
                return await compressImage(file);
              } catch (err) {
                toast.error(t("compressionError"), {});
                return file;
              }
            }
            return file;
          })
        );
      }
      onFileSelect(processedFiles);
    },
    [onFileSelect]
  );

  const onDropRejected = () => {
    toast.error(t("invalidFileUploaded"), {});
  };

  const { getRootProps, getInputProps, isDragAccept, isDragReject, isFocused } =
    useDropzone({
      onDrop,
      onDropRejected,
      accept: acceptedFileTypes,
    });

  return (
    <Box
      className={`my-2 p-2 border-dashed border-2 border-gray-500/40 transition-colors rounded-sm ${
        isFocused ? "border-gray-500" : ""
      } ${isDragAccept ? "border-green-500" : ""} ${
        isDragReject ? "border-red-500" : ""
      }`}
      {...getRootProps()}
    >
      <input {...getInputProps()} />
      <Box className="flex flex-col justify-center items-center cursor-pointer">
        <AddPhotoAlternateOutlinedIcon sx={{ height: "3rem", width: "3rem" }} />
        <Box>{instruction}</Box>
        {t("or")}
        <Button variant="outlined" sx={{ my: 1 }}>
          {t("selectFiles")}
        </Button>
      </Box>
    </Box>
  );
}
